import AppLayout from '../../../../component/appLayout';
import SVGIcon from '../../../../assets/images/svg/SVGIcon';
import ButtonV2 from '../../../../component/button/buttonV2';
import vercelLogo from '../../../../assets/images/IntegrationLogos/vercel-logo.svg';
import vercelDarkLogo from '../../../../assets/images/IntegrationLogos/vercel-dark-logo.svg';
import { useSelector } from 'react-redux';
import { RootReducerInterface } from '../../../../interfaces/RootReducerInterface';
import { useHistory } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import ModalCustom from '../../../../component/models/modal';
import DeleteModal from '../../../../component/models/deleteModel';
import {
  BottomContent,
  Content,
  Data,
  DataTitle,
  Group,
  Header,
  HeaderText,
  Icon,
  LeftSide,
  LeftSideData,
  Logo,
  Main,
  RemoveButton,
  RepositoryData,
  Subheader,
  Text,
  Title
} from '../githubIntegration/styles';
import { REACT_APP_VERCEL_CLIENT_ID } from '../../../../global/environment';
import { deleteVercelAccount, getVercelAccount } from '../../../../services/vercelService';
import { useDispatch } from 'react-redux';
import { VercelAccountInterface } from '../../../../interfaces/SettingsInterface';
import { rootStore } from '../../../../mobx/rootStore';
import { BUTTON_TYPE } from '../../../../global/constants';

export default function VercelIntegration() {
  //States
  const [vercelAccountList, setVercelAccountList] = useState([]);
  const [selectedModalId, setSelectedModalId] = useState<string | null>(null);
  //Use selector state variable
  const stateSelector = useSelector((state: RootReducerInterface) => state);
  const { settings: settingsSelector } = stateSelector;
  const { themeMode, loading } = settingsSelector;
  // mobx
  const { workspaceStore } = rootStore || {};
  const { currentWorkspace } = workspaceStore || {};
  //Other variable
  const history = useHistory();
  const dispatch = useDispatch();

  const loadData = useCallback(async () => {
    if (currentWorkspace?.id) {
      const response = await dispatch(getVercelAccount());
      if (response) {
        setVercelAccountList(response);
      }
    }
  }, [currentWorkspace?.id, dispatch]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  // Handles navigation back to previous page
  const handleBackClick = useCallback(() => {
    history.goBack();
  }, [history]);

  //open delete model
  const handleOpenDeleteModel = useCallback((id: string) => {
    setSelectedModalId(id);
  }, []);

  //   close Delete Model
  const handleCloseDeleteModel = useCallback(() => {
    setSelectedModalId(null);
  }, []);

  const linkVercel = useCallback(() => {
    const array = new Uint8Array(16);
    crypto.getRandomValues(array);
    const state = Array.from(array, (byte) => byte.toString(16).padStart(2, '0')).join('');
    // eslint-disable-next-line max-len
    const link = `https://vercel.com/integrations/${REACT_APP_VERCEL_CLIENT_ID}/new?state=${state}&scope=team%20project%20deployment`;
    window.open(link, '_blank', 'noopener,noreferrer');
  }, []);

  const handleDeleteVercelAccount = useCallback(async () => {
    const response = await dispatch(deleteVercelAccount(selectedModalId));
    if (response) {
      loadData();
      setSelectedModalId(null);
    }
  }, [dispatch, loadData, selectedModalId]);

  return (
    <>
      <AppLayout>
        <Group>
          <Main>
            <Header>
              <Icon onClick={handleBackClick}>
                <SVGIcon name='left-arrow-icon' width='16' height='16' viewBox='0 0 16 16' className='arrow-icon' />
              </Icon>
              <Title>Integrations</Title>
            </Header>
          </Main>
          <BottomContent>
            <Subheader>
              <LeftSide>
                <Logo>
                  {themeMode?.theme === 'dark' ? (
                    <img src={vercelDarkLogo} alt='vercel-logo' width={42} height={42} />
                  ) : (
                    <img src={vercelLogo} alt='vercel-logo' width={42} height={42} />
                  )}
                </Logo>
                <Content>
                  <Text>Vercel</Text>
                  <HeaderText>Deploy and track builds within tasks.</HeaderText>
                </Content>
              </LeftSide>
              <ButtonV2 variant={BUTTON_TYPE.PRIMARY} onClick={linkVercel} title='Link Vercel Account' />
            </Subheader>
            <RepositoryData>
              {vercelAccountList?.length > 0 &&
                vercelAccountList?.map((item: VercelAccountInterface) => {
                  return (
                    <Data key={item?.id}>
                      <LeftSideData>
                        <DataTitle>{item?.name}</DataTitle>
                        {/* <Datatext>{item?.description} </Datatext> */}
                      </LeftSideData>
                      <RemoveButton onClick={() => handleOpenDeleteModel(item?.id)}>Remove</RemoveButton>
                    </Data>
                  );
                })}
            </RepositoryData>
          </BottomContent>
        </Group>
      </AppLayout>
      <ModalCustom width={334} open={selectedModalId !== null} onClose={handleCloseDeleteModel}>
        <DeleteModal
          onOk={handleDeleteVercelAccount}
          modalTitle=' Remove Vercel Account'
          description=' Are you sure you want to remove this account?'
          onClose={handleCloseDeleteModel}
          loading={loading}
        />
      </ModalCustom>
    </>
  );
}
